// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2vIbK","signatureButtonsRight":"ModalSign_signatureButtonsRight__2ewhE"};